import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterUsersComponent } from "./filter-users.component";
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

@NgModule({
  declarations: [FilterUsersComponent],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot()
  ],
  exports: [FilterUsersComponent]
})
export class FilterUsersModule { }
